import { z } from 'zod';

/**
 * In-app notifications written when the pipeline finishes processing an
 * invoice (#75 D-002). The uploader gets notified, plus admins via a
 * separate broadcast channel.
 */
export const NotificationTypeEnum = z.enum([
  'invoice_processed',
  'invoice_failed',
  'invoice_manual_review',
  'invoice_comment_created',
  'invoice_updated',
  'invoice_status_changed',
  'invoice_skonto_reminder',
  'rule_applied',
  'system',
]);
export type NotificationType = z.infer<typeof NotificationTypeEnum>;

export const NotificationPayloadSchema = z.record(z.unknown());
export type NotificationPayload = z.infer<typeof NotificationPayloadSchema>;

export const NotificationSchema = z.object({
  id: z.string(),
  userId: z.string(),
  /** NULL when the notification is system-wide / non-scoped. */
  customerId: z.string().nullable(),
  type: NotificationTypeEnum,
  payload: NotificationPayloadSchema,
  read: z.boolean(),
  createdAt: z.string().datetime(),
  readAt: z.string().datetime().nullable().optional(),
});
export type Notification = z.infer<typeof NotificationSchema>;

export const NotificationListItemSchema = NotificationSchema.extend({
  customerName: z.string().nullable(),
});
export type NotificationListItem = z.infer<typeof NotificationListItemSchema>;

export const NotificationListResponseSchema = z.object({
  items: z.array(NotificationListItemSchema),
});
export type NotificationListResponse = z.infer<typeof NotificationListResponseSchema>;

export const NotificationCountsResponseSchema = z.object({
  total: z.number().int().nonnegative(),
  unread: z.number().int().nonnegative(),
});
export type NotificationCountsResponse = z.infer<typeof NotificationCountsResponseSchema>;
